import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Typography } from "@mui/material";
import Carousel from "better-react-carousel";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../../components/Custom3dotString";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomUpload from "../../../../components/CustomUpload";
import {
  createFilesByAppointmentIdWoLoader,
  deleteFileByIdWoLoader,
  updateFilesByIdWoLoader,
} from "../../../../redux/reducers/clinicSlice";
import { getPetsCompliantSummaryWoLoader } from "../../../../redux/reducers/petSlice";
import { addIcon, delBtn, eyeBtn } from "../../../../util/CommonIconStyle";
import { urlToFile } from "../../../../util/function";
import FilesWithCloseButton from "./FilesWithCloseButton";

const Files = () => {
  const dispatch = useDispatch();
  const [uploadVsble, setUploadVsble] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [prevModVsble, setPrevModVsble] = useState(false);
  const [delModVsble, setDelModVsble] = useState(false);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  // useEffect(() => {
  //   callApi();
  // }, []);

  const callApi = () => {
    dispatch(
      getPetsCompliantSummaryWoLoader(reqDet?.appointment?.appointmentId)
    );
  };

  const handleRemoveFile = (ind) => {
    const reqFiles = files?.filter((fl, i) => i !== ind);
    setFiles(reqFiles);
  };

  const onUploadFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists = files?.length > 0 ? [...files] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [...fileLists, { file: file, previewUrl: reader.result }];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(readFiles)
      .then(() => setFiles(fileLists))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleSubmit = async () => {
    if (files?.length === 0) return;
    const form = new FormData();
    form.append("name", selectedFile?.name ?? `${Date.now()}File`);
    const filePromises = files?.map(async (fle) => {
      if (fle?.file) {
        return fle?.file; // Local File
      } else {
        return await urlToFile(fle?.previewUrl); // Remote File
      }
    });
    const finalFiles = await Promise.all(filePromises);
    finalFiles?.forEach((file) => {
      form.append("files", file);
    });

    if (selectedFile?.fileId) {
      dispatch(
        updateFilesByIdWoLoader({ fileId: selectedFile?.fileId, form })
      ).then((res) => {
        if (res?.payload) {
          setSelectedFile(null);
          setUploadVsble(false);
          setFiles([]);
          callApi();
        }
      });
    } else {
      dispatch(
        createFilesByAppointmentIdWoLoader({
          apntId: reqDet?.appointment?.appointmentId,
          form,
        })
      ).then((res) => {
        if (res?.payload) {
          setUploadVsble(false);
          setFiles([]);
          callApi();
        }
      });
    }
  };

  const handleDelete = (fle) => {
    setSelectedFile(fle);
    setDelModVsble(true);
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedFile(null);
  };

  const onCofirmDelete = () => {
    if (!selectedFile?.fileId) return;
    dispatch(deleteFileByIdWoLoader(selectedFile?.fileId)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        callApi();
      }
    });
  };

  const handleEdit = (fle) => {
    if (reqDet?.appointment?.appointmentStatus?.toLowerCase() !== "completed") {
      return;
    }
    setSelectedFile(fle);
    setFiles(fle?.files?.map((fle) => ({ file: null, previewUrl: fle })));
    setUploadVsble(true);
  };

  const handleView = (fle) => {
    setSelectedFile(fle);
    setPrevModVsble(true);
  };

  const onClosePrevMod = () => {
    setPrevModVsble(false);
    setSelectedFile(null);
  };

  return (
    <div>
      {!uploadVsble ? (
        <div>
          <div className="mt10 mh20">
            <div className="flex-row-ali-cen mh20">
              <div className="w40Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Name
                </Typography>
              </div>
              <div className="w40Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Date
                </Typography>
              </div>
              <div className="w20Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Actions
                </Typography>
              </div>
            </div>
            <div className="blue-hor-split mt5" />
            {reqDet?.files?.length > 0
              ? reqDet?.files?.map((fle) => (
                  <div className="flex-row-ali-cen mh20 mt10" key={fle?.fileId}>
                    <div className="w40Per">
                      <div
                        className="flex-row-ali-cen"
                        onClick={() => handleEdit(fle)}
                      >
                        <Custom3dotString
                          str={fle?.name}
                          className="txt-semi-bold blue-color fs12 underline cursor"
                          length={25}
                        />
                      </div>
                    </div>
                    <div className="w40Per">
                      <Typography className="font-medium gray34 fs12">
                        {moment(new Date(fle?.updatedDate)).format(
                          "DD MMM YYYY | HH:mm"
                        )}
                      </Typography>
                    </div>
                    <div className="w20Per">
                      <div className="flex-row-ali-cen">
                        {reqDet?.appointment?.appointmentStatus?.toLowerCase() !==
                        "completed" ? (
                          <div
                            className="cursor"
                            onClick={() => handleDelete(fle)}
                          >
                            <div className="flex-center">
                              <DeleteOutlineIcon sx={delBtn} />
                            </div>
                            <Typography className="red3 fs8 txt-semi-bold text-align-center">
                              Delete
                            </Typography>
                          </div>
                        ) : null}
                        <div
                          className="cursor ml20"
                          onClick={() => handleView(fle)}
                        >
                          <div className="flex-center">
                            <VisibilityIcon sx={eyeBtn} />
                          </div>
                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                            View
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              : null}
            {reqDet?.appointment?.appointmentStatus?.toLowerCase() !==
            "completed" ? (
              <div
                className="flex-row-ali-cen mt20 cursor"
                onClick={() => setUploadVsble(true)}
              >
                <div className="flex-center plus-icon">
                  <AddIcon sx={addIcon} />
                </div>
                <Typography className="blue-color fs16 ml5 font-bold">
                  Add
                </Typography>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div className="mt20 mh20">
          {files?.length > 0 ? (
            <FilesWithCloseButton
              files={files}
              onClickFile={(i, file) => handleRemoveFile(i)}
            />
          ) : null}

          <CustomUpload onUploadFile={onUploadFile} multipleNew multiFiles />

          <div className="flex1-center mb10">
            <div>
              <CustomButton text="Submit" smallBtn onClick={handleSubmit} />
            </div>
          </div>
        </div>
      )}
      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete Form"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the form?
        </Typography>

        <div className="clinic-mod-btn-pos mb10 mt15">
          <div className="mr10">
            <CustomButton text="Yes" redBtn onClick={onCofirmDelete} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={prevModVsble}
        onClose={onClosePrevMod}
        header="Preview"
        modal
        modalWidth={50}
      >
        <Carousel cols={1} rows={1} gap={10} loop showDots>
          {selectedFile?.files?.map((fle) => {
            const fileType = fle?.split(".").pop();
            const isImg = ["png", "jpg", "jpeg"].includes(fileType);

            return (
              <Carousel.Item>
                <div className="flex-center">
                  {isImg ? (
                    <img src={fle} alt="" className="chat-file-prev" />
                  ) : (
                    <iframe
                      className="chat-file-prev"
                      frameborder="0"
                      src={`https://docs.google.com/gview?url=${fle}&embedded=true`}
                    />
                  )}
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </CustomModal>
    </div>
  );
};

export default Files;
